import BackToTop from '@elem/compCommon/BackToTop';
import EmailSubscribe, { PAGE_TYPE } from '@elem/compCommon/EmailSubscribe';
import ShopifyCartIcon from '@elem/compCommon/ShopifyCartIcon';
import SideMenu, { SideMenuProps } from '@elem/compCommon/SideMenu';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import ShopifyShoppingCart from 'elem/compCommon/ShopifyShoppingCart';
import { ShopifyCartItemType } from 'elem/compCommon/ShopifyShoppingCart/const';
import { createPortal } from 'react-dom';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import G from './components/G';
import H from './components/H';
import O from './components/O';
// import P from './components/P';
import ProductInlineBanner from '@/components/PIBanner';
import { useGlobal } from '@/utils/useGlobal';
import Q from './components/Q';
import R from './components/R';
import Rooftop from './components/Rooftop';
import S from './components/S';
import SolarEnergySolutions from './components/SolarEnergySolutions';
import TaxCredit from './components/TaxCredit';
import WholeHome from './components/WholeHome';
import USC from './components/UsPage/C'

export default function IndexDynamic() {
    const { useState, useRouter, useLang, useEffect } = useGlobal();
    const [shoppingCarts, setShoppingCarts] = useState([]);
    const [visible, setVisible] = useState(false);
    const [isClient, setIsClient] = useState(false);
    const [updateSolar, setUpdateSolar] = useState(null);
    const { locale } = useRouter();
    const { t } = useLang('costsaving');
    const isUs = ['us'].includes(locale);

    const obj: SideMenuProps = {
        items: [
            { text: t('secC_btn1'), link: '#cost-saving-C' },
            { text: t('secC_btn2'), link: '#cost-saving-E' },
            // { text: t('secC_btn3'), link: '#cost-saving-J' },
            // { text: t('secC_btn4'), link: '#cost-saving-L' },
        ],
    };

    const handleAddCart = (cards: ShopifyCartItemType[]) => {
        let result = JSON.parse(JSON.stringify(shoppingCarts));
        cards?.map((card: ShopifyCartItemType) => {
            const obj: ShopifyCartItemType = JSON.parse(JSON.stringify(card));
            if (card?.parentVariantId) {
                const target = result.find(
                    (item: ShopifyCartItemType) =>
                        item?.productId === card?.productId && item?.variantId === card?.variantId && item?.parentVariantId === card?.parentVariantId,
                );
                // 附属产品
                obj.quantity = Number(obj?.inventory) > 0 ? obj.quantity : 0;
                result = result.filter((item: ShopifyCartItemType) => !(item?.parentVariantId === card?.parentVariantId));
                if (target) {
                    result = [
                        obj,
                        ...result?.filter((item: any) => !(item?.variantId === target?.variantId && item?.parentVariantId === item?.parentVariantId)),
                    ];
                } else {
                    result = [obj, ...result];
                }
            } else {
                // 主产品
                const target = result.find((item: ShopifyCartItemType) => item?.productId === card?.productId && item?.variantId === card?.variantId);
                if (target) {
                    obj.quantity = target.quantity;
                    result = [
                        obj,
                        ...result?.filter((item: ShopifyCartItemType) => !(item?.productId === card?.productId && item?.variantId === card?.variantId)),
                    ];
                } else {
                    obj.quantity = Number(obj?.inventory) > 0 ? 1 : 0;
                    result = [obj, ...result];
                }
            }
        });
        //setShoppingCarts(result);
        EcoDesignEventsBus.emit('eco-cart-add', result);
        setVisible(true);
    };

    const handleCallback = (carts: ShopifyCartItemType[], isClose?: boolean, target?: string) => {
        //setShoppingCarts(carts);
        EcoDesignEventsBus.emit('eco-cart-add', carts);
        if (isClose) {
            setVisible(false);
        }
        if (target) {
            setUpdateSolar(target);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <>
            {isUs && (
                <>
                    <SolarEnergySolutions />
                    <Rooftop />
                    <WholeHome />
                    <F callBuy={handleAddCart} updateSolar={updateSolar} />
                    <C />
                    <D callBuy={handleAddCart} updateSolar={updateSolar} />
                    <TaxCredit />
                    <R />
                </>
            )}
            {!isUs && (
                <>
                    <B />
                    <C />
                    <D callBuy={handleAddCart} updateSolar={updateSolar} />
                    <E />
                    <F callBuy={handleAddCart} updateSolar={updateSolar} />
                    {['us', 'ca'].includes(locale) && <ProductInlineBanner />}
                    {locale !== 'ca' && <G />}
                    {locale === 'ca' && <EmailSubscribe locale={locale} className="email-subscribe" pageType={PAGE_TYPE.CostSaving} entry_position={7} />}
                    <H />
                    <O />
                    {/* <P /> */}
                    {!['us', 'ca'].includes(locale) && <Q />}
                    <R />
                    <S />
                </>
            )}

            {visible && isClient && createPortal(<ShopifyShoppingCart callback={handleCallback} items={shoppingCarts} />, document.body)}
            {isClient &&
                createPortal(
                    <ShopifyCartIcon
                        quantity={shoppingCarts.reduce((prev: number, curItem: ShopifyCartItemType) => {
                            return prev + Number(curItem.quantity);
                        }, 0)}
                        callback={() => setVisible(true)}
                    />,
                    document.body,
                )}
            {isClient && createPortal(<BackToTop />, document.body)}
            {isClient && createPortal(<SideMenu items={obj.items} />, document.querySelector('#Widgets-box-in2-right-id') || document.body)}
        </>
    );
}
